/**
 * @module app.shared
 */

import { LogManager, transient } from 'aurelia-framework';
import { LogItem, LogTarget, LogPriority, ILogDefaults, ILogItem } from 'app/shared/lib/logging/log-item';

@transient()
export class AppLogger implements ILogDefaults {

    public source: any;
    public target: LogTarget = 'all';
    public priority: LogPriority = 'normal';
    public trace: string = '';
    public style: string = '';

    constructor() { }

    public error(message: string, errorOrDetails?: unknown): void {
        this.log({ level: 'error', message, error: this.getError(errorOrDetails), details: this.getDetails(errorOrDetails), timestamp: LogItem.getTimestamp() });
    }

    public warn(message: string, errorOrDetails?: unknown): void {
        this.log({ level: 'warn', message: message, error: this.getError(errorOrDetails), details: this.getDetails(errorOrDetails), timestamp: LogItem.getTimestamp() });
    }

    public info(message: string, errorOrDetails?: unknown): void {
        this.log({ level: 'info', message: message, error: this.getError(errorOrDetails), details: this.getDetails(errorOrDetails), timestamp: LogItem.getTimestamp() });
    }

    public debug(message: string, errorOrDetails?: unknown): void {
        this.log({ level: 'debug', message: message, error: this.getError(errorOrDetails), details: this.getDetails(errorOrDetails), timestamp: LogItem.getTimestamp() });
    }

    public log(item: Partial<ILogItem>): void {
        const details = LogItem.create(item, this);
        LogManager.getLogger(details.source)[details.level](details.message, details);
    }

    private getError(errorOrDetails: unknown): Error | null {
        if(errorOrDetails && errorOrDetails instanceof Error) { return errorOrDetails; }
        return null;
    }

    private getDetails(errorOrDetails: unknown): any {
        if(errorOrDetails && errorOrDetails instanceof Error) { undefined; }
        return errorOrDetails;
    }

}
